module.exports = __webpack_public_path__ + "static/media/port.63dc46d8.png";